/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useEffect, useMemo, useReducer, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useServices } from '../services';

export const genericProcedureDetailsContext = createContext({
  aggregatedGenericProcedure: {
    buyer: {},
    genericProcedure: {},
    car: {},
    labels: [],
    agent: {},
    account: {},
  },
  setAggregatedGenericProcedure: () => {},
  genericProcedureLoading: false,
  updater: 0,
  forceUpdate: () => {},
  genericProcedureIncidents: [],
});

export function GenericProcedureDetailsContextProvider({ children }) {
  const [aggregatedGenericProcedure, setAggregatedGenericProcedure] = useState({
    buyer: {},
    genericProcedure: {},
    car: {},
    labels: [],
    agent: {},
    account: {},
  });
  const [genericProcedureLoading, setGenericProcedureLoading] = useState(true);

  const [genericProcedureIncidents, setGenericProcedureIncidents] = useState(
    [],
  );

  const [updater, forceUpdate] = useReducer((x) => x + 1, 0);

  const { code } = useParams();

  const { getGenericProcedureByCode, fetchAllIncidentsByEntityId } =
    useServices();

  useEffect(() => {
    const fetchGenericProcedure = async () => {
      const response = await getGenericProcedureByCode(code);

      const incidents = await fetchAllIncidentsByEntityId(
        response?.genericProcedure?.id,
      );
      setGenericProcedureIncidents(incidents);

      setAggregatedGenericProcedure(response);
      setGenericProcedureLoading(false);
    };
    fetchGenericProcedure();
  }, [code, updater]);

  const value = useMemo(
    () => ({
      aggregatedGenericProcedure,
      setAggregatedGenericProcedure,
      updater,
      forceUpdate,
      genericProcedureLoading,
      genericProcedureIncidents,
    }),
    [
      aggregatedGenericProcedure,
      setAggregatedGenericProcedure,
      updater,
      forceUpdate,
      genericProcedureLoading,
      genericProcedureIncidents,
    ],
  );
  return (
    <genericProcedureDetailsContext.Provider value={value}>
      {children}
    </genericProcedureDetailsContext.Provider>
  );
}
